import { storageKeys } from '../../../app/config';
import { rootRoutes } from '../../../app/routers/rootRoutes';
import { rootApi } from '../../../app/stores/baseQuery';

export const resetDataApp = () => {
  localStorage.removeItem(storageKeys.token);
  rootApi.util.resetApiState();
  document.location.href = `${document.location.origin}${rootRoutes.login}`;
};
